module.exports = __webpack_public_path__ + "static/TakkScroll3-cb1693f464390781ab19567711884b99.png";